<h2>VC Split & Edit Content</h2>
<app-project-content [userInfos]="userInfos" [data]="dataSource" [platformInfos]="platformInfos"></app-project-content>